import React, { useState, useEffect } from 'react';
import { drawerWidth, drawerWidthCollapse, IS_DRAWER_OPEN} from 'components/layout/ResponsiveDrawer/styles';
import { Stage, Layer, Star, Text, Group, Rect, Line, Image, Circle } from 'react-konva';
import { bttHeight, bttWidth, columWidth, jobHeight, jobIconFit, jobTopMagin, jobWidth } from './workflowConfig';
import {
  StatusIcon,
  StatusColor,
  JobIcon,
  AddIcon,
  ShareIcon,
  generateShapes,
  getTypeText,
  getLineColor,
  getDash,
  setUpComponentUtils,
  setUpScroll,
  formatWfParam
} from './workflowUtils';
import { ROUTES } from 'consts';
import { useHistory, withRouter } from 'react-router-dom';
import moment from 'moment';


export default function Workflow ({
  handleAction,
  wfParam,
  updateWF,
  mode,
  scale=null,
  scaleSize=1,
  scrollScale=false,
  setLinkMode={},
  linkMode={},
  handleMoveJob={}
}) {
  const history = useHistory();
  const wfParamFormatted = formatWfParam(wfParam);
  const [wf, setWf] = useState(wfParamFormatted);
  const [itemSelected, setItemSelected] = useState(null);
  const [nodeSelected, setNodeSelected] = useState(null);
  const [stage, setStage] = useState({ scale: scaleSize, x: 0, y: 0 });
  const { clickJob } = setUpComponentUtils(wf, setWf);
  const { handleWheel } = setUpScroll(stage, setStage);
  const [jobDrag, setJobDrag] = useState({ job: null, x: 0, y: 0, columna:0, pos:0 });

  const handleItemEnter = (e) => {
    const container = e.target.getStage().container();
    container.style.cursor = "pointer";
    //setItemSelected(e.target.attrs.name);
  };

  const handleItemLeave = (e) => {
    const container = e.target.getStage().container();
    container.style.cursor = "default";
    //setItemSelected(null);
  };

  function handleSetLinkMode(props) {
    const {
      active=linkMode.active,
      selected=linkMode.selected,
      nodes=linkMode.nodes
    } = props;
    setLinkMode({
      active,
      selected,
      nodes
    });
  }

  function handleCheckNodeLink(job) {
    const id = job.id_nodo;
    if (!linkMode.active) return false;
    if (!linkMode.nodes[id]) return false;
    else return true;
  }

  function handleEditLinkNodes(job) {
    const id = job.id_nodo;
    let nodes = linkMode.nodes;

    if (nodes[id]) delete nodes[id];
    else {
      nodes = {
        ...nodes,
        [id]: job
      }
    }

    handleSetLinkMode({ nodes });
  }

  function cleanLinkMode() {
    handleSetLinkMode({
      active: false,
      selected: null,
      nodes: {}
    });
  }

  function linkProps(job, index) {
    let props =  {
      name: `link-${index}`,
      // onMouseEnter: handleItemEnter,
      // onMouseLeave: handleItemLeave,
    }

    if (mode !== "ej") props["onClick"] = (e) => {
      handleSetLinkMode({ active: true, selected: job });
      handleAction(e, job, 'link');
    }

    return props;
  }

  function columnAddProps(index) {
    let props = {
      name: `column-add-${index}`,
      // onMouseEnter: handleItemEnter,
      // onMouseLeave: handleItemLeave,
    }
    if (linkMode.active) return;
    if (mode !== "ej") props["onClick"] = (e) => handleAction(e, null, 'add-column', index);

    return props;
  }

  function columnDeleteProps(index) {
    let props = {
      name: `column-delete-${index}`,
      // onMouseEnter: handleItemEnter,
      // onMouseLeave: handleItemLeave,
    }
    if (linkMode.active) return;
    if (mode !== "ej") props["onClick"] = (e) => handleAction(e, null, 'delete-column', index);

    return props;
  }

  function addProps(job, j) {
    let props = {
      name: `add-${j}`,
      // onMouseEnter: handleItemEnter,
      // onMouseLeave: handleItemLeave,
    }
    if (linkMode.active) return;
    if (mode !== "ej") props["onClick"] = (e) => handleAction(e, job, 'add');

    return props;
  }

  function nodeProps(job, index) {
    let props = { name: `${job.id_nodo}-${index}` };

    
      props["onClick"] = (e) => {
        if (mode === "ej" ) {
          if (job.job_id){
            if (job.type === "WF"){
              history.push(`${ROUTES.JOB_RUN_WORKFLOW}/${job.job_id}`);
            }else{
              history.push(`${ROUTES.JOB_RUN_TEMPLATE}/${job.job_id}`);
            }
          }
        }else{
          if (!linkMode.active) {
            setNodeSelected(e.target.attrs.name);
            clickJob(job);
            handleAction(e, job, 'edit');
          } else if (linkMode.selected && linkMode.selected.id_nodo !== job.id_nodo) {
            handleEditLinkNodes(job);
          }
        }
      }
    return props;
  }

  function startDrag(e, job, x, y, columna, pos){
    setJobDrag({ job: job, x: x, y: y, columna:columna, pos:pos })
  }

  function endDrag(e, job){
    const currentColumn = jobDrag.columna-1;
    let new_column = currentColumn + Math.round(e.target.attrs.x/columWidth );
    let new_pos = jobDrag.pos + Math.round(e.target.attrs.y/(jobHeight+jobTopMagin));
    if (new_column+1 < wf.length){
      handleMoveJob(job, currentColumn , jobDrag.pos, new_column, new_pos)
    }
    e.target.setX(0);
    e.target.setY(0);
    setJobDrag({ job: null, x: 0, y: 0, columna:0, pos:0 });
  }


  
  const formatText = (job)=>{
    let retorna = "";
    try{
      if(job.start && job.type != 'FI'){
        retorna = moment(job.start).add(-3, 'hours').format('HH:mm');
        const start = moment(job.start).add(-3, 'hours');
        const finish = moment(job.finish).add(-3, 'hours');
        
        const segundos= finish.diff(start, 's');
        if (!isNaN(segundos) && segundos != 'NaN'){
          retorna += " - "+segundos+"s";
        }
      }
    }catch(err){
      console.log(err)
    }

    return retorna;
  }

  function renderWF(mode) {
    return wf.map((column, i) => {

      return (
        <Group
          key={`column-${i}`}
          x={i*columWidth}
          y={30}
        >
          { (mode !== 'ej' && (i !== wf.length-1)) &&
            <React.Fragment>
              <Rect
                y={-28}
                x={columWidth-jobWidth/2}
                width={bttWidth}
                height={bttHeight-4}
                cornerRadius={10}
                stroke="#0792F9"
                strokeWidth={1}
                shadowColor="#0792F9"
                shadowBlur={10}
                shadowOffsetX={2}
                shadowOffsetY={2}
                shadowOpacity= {itemSelected === `add-column-${i}` ? 0.2 : 0}
                opacity={0.7}
                { ...columnAddProps(i) }
              />
              <Text
                x={columWidth-jobWidth/2 + 6}
                y={-24}
                text={"add column"}
                fill="#0792F9"
                opacity={0.7}
                fontSize={9}
                { ...columnAddProps(i) }
              />
            </React.Fragment>
          }

          { (mode !== 'ej' && (column.length === 0)) &&
            <React.Fragment>
              <Rect
                y={-28}
                x={-20 + jobWidth/2}
                width={bttWidth}
                height={bttHeight-4}
                cornerRadius={10}
                stroke="red"
                strokeWidth={1}
                shadowColor="red"
                shadowBlur={10}
                shadowOffsetX={2}
                shadowOffsetY={2}
                shadowOpacity= {itemSelected === `add-column-${i}` ? 0.2 : 0}
                opacity={0.7}
                { ...columnDeleteProps(i) }
              />
              <Text
                x={-20 + jobWidth/2 + 6}
                y={-24}
                text={"remove col"}
                fill="red"
                opacity={0.7}
                fontSize={9}
                { ...columnDeleteProps(i) }
              />
            </React.Fragment>
          }

          { column.map((job, j) =>
            (
              <Group
                key={`${job.title}-${j}`}
                draggable={job.type !== "ST" && mode !== 'ej'}
                ondragstart={mode !== 'ej'? (e) => {
                  startDrag(e, job, i*columWidth, j*(jobHeight+jobTopMagin), i, j);
                } : null}
                ondragend={mode !== 'ej'? (e) => {
                  endDrag(e, job);
                } : null}
              >
                <Rect
                  x={10}
                  y={j*(jobHeight+jobTopMagin)}
                  width={jobWidth}
                  height={jobHeight}
                  fill={(linkMode.active && linkMode.selected.id_nodo !== job.id_nodo) ? '#F5FBFF' : "#FFF"}
                  cornerRadius={12}
                  stroke={handleCheckNodeLink(job) ? "#0792F9" : StatusColor(job.status, mode)}
                  strokeWidth={nodeSelected === `${job.id_nodo}-${j}` ? 2.5 : 1}
                  shadowColor="black"
                  shadowBlur={10}
                  shadowOffsetX={3}
                  shadowOffsetY={3}
                  shadowOpacity={itemSelected === `${job.id_nodo}-${j}` ? 0.1 : 0}
                  { ...nodeProps(job, j, i) }
                  onMouseEnter={handleItemEnter}
                  onMouseLeave={handleItemLeave}
                />

                { (job.type === "FI" || job.type === "ST") &&
                  <Rect
                    x={10}
                    y={j*(jobHeight+jobTopMagin)}
                    width={jobWidth}
                    height={jobHeight/2}
                    fill="#E8E8E8"
                    cornerRadius={[12, 12, 0, 0]}
                    stroke={StatusColor(job.status, mode)}
                    strokeWidth={1}
                  />
                }

                <Text
                  text={job.type === "FI" ? "End" : job.title}
                  fontSize={13}
                  x={18}
                  y={j*(jobHeight+jobTopMagin)+8}
                  width={jobWidth-8}
                  height={10}
                  { ...nodeProps(job, j, i) }
                />
                <JobIcon { ...nodeProps(job, j, i) } x={14} j={j} job={job}/>
                { mode === 'ej' && <StatusIcon { ...nodeProps(job, j, i) } x={jobWidth-14} j={j} job={job}/> }

                <Text
                  { ...nodeProps(job, j, i) }
                  text={getTypeText(job.type)}
                  fontSize={11}
                  fill="#B7B7B7"
                  x={34}
                  y={j*(jobHeight+jobTopMagin)+jobHeight-18}
                  width={jobWidth-8}
                  height={10}
                />

                <Text
                  { ...nodeProps(job, j, i) }
                  text={formatText(job)}
                  fontSize={11}
                  fill="#B7B7B7"
                  x={34}
                  y={j*(jobHeight+jobTopMagin)+24}
                  width={jobWidth-8}
                  height={10}
                />

                { (job.actions && mode === 'ed') &&
                  <React.Fragment>
                    { job.type !== "ST" &&
                      <React.Fragment>
                        <Rect
                          x={10}
                          y={j*(jobHeight+jobTopMagin)+jobHeight+3}
                          width={bttWidth}
                          height={bttHeight}
                          fill="#0792F9"
                          cornerRadius={[10, 0, 10, 10]}
                          shadowColor="#0792F9"
                          shadowBlur={10}
                          shadowOffsetX={2}
                          shadowOffsetY={2}
                          shadowOpacity= {itemSelected === `link-${j}` ? 0.2 : 0}
                          { ...linkProps(job, j, i) }
                        />
                        <ShareIcon
                          x={18}
                          y={j*(jobHeight+jobTopMagin)+jobHeight+6}
                          { ...linkProps(job, j, i) }
                        />
                        <Text
                          x={36}
                          y={j*(jobHeight+jobTopMagin)+jobHeight+8}
                          text={"link"} fill="#FFF"
                          { ...linkProps(job, j, i) }
                        />
                      </React.Fragment>
                    }
                    { job.type !== "FI" &&
                      <React.Fragment>
                        <Rect
                          x={10+jobWidth-bttWidth}
                          y={j*(jobHeight+jobTopMagin)+jobHeight+3}
                          width={bttWidth}
                          height={bttHeight}
                          fill="#51B948"
                          cornerRadius={[0, 10, 10, 10]}
                          shadowColor="#51B948"
                          shadowBlur={10}
                          shadowOffsetX={2}
                          shadowOffsetY={2}
                          shadowOpacity= {itemSelected === `add-${j}` ? 0.2 : 0}
                          { ...addProps(job, j) }
                        />
                        <AddIcon
                          x={10+jobWidth-bttWidth+7}
                          y={j*(jobHeight+jobTopMagin)+jobHeight+8}
                          { ...addProps(job, j) }
                        />
                        <Text
                          x={10+jobWidth-bttWidth+20}
                          y={j*(jobHeight+jobTopMagin)+jobHeight+8}
                          text={"add"}
                          fill="#FFF"
                          { ...addProps(job, j) }
                        />
                      </React.Fragment>
                    }
                  </React.Fragment>
                }

                { job.type !== "ST" &&
                  <Circle
                    x={10}
                    y={j*(jobHeight+jobTopMagin)+jobHeight/2}
                    stroke="#B5B5B5"
                    strokeWidth={3}
                    radius={4}
                    fill="#FFF"
                  />
                }

                { job.type !== "FI" &&
                  <Circle
                    x={10+jobWidth}
                    y={j*(jobHeight+jobTopMagin)+jobHeight/2}
                    stroke="#B5B5B5"
                    strokeWidth={3}
                    radius={4} fill="#FFF"
                  />
                }

              </Group>
            ))
          }
        </Group>
      );
    });
  }

  function renderWfConnection() {
    const { getNodePosition } = setUpComponentUtils(wf);

    const lsJobs = [];
    wf.forEach((column,index) => {
      column.forEach((job, i) => {
        const newJob = JSON.parse(JSON.stringify(job))
        newJob.col = index;
        newJob.pos = i;
        lsJobs.push(newJob)
      });
    });

    const connections = [];

    lsJobs.forEach((job, i) => {
      const jobPosition = getNodePosition(job.id_nodo) ;
      jobPosition.y += (jobHeight/2);
      jobPosition.x += 10;

      job.conn &&
        job.conn.forEach((con, j) => {
          const conjobPosition = getNodePosition(con.id_nodo);
          if (!conjobPosition) return;
          conjobPosition.y += (jobHeight/2);
          conjobPosition.x += 8+jobWidth;

          const p1x=0;
          const p1y=0;
          const p2x=12;
          const p2y=0;
          const p4x=-1*(conjobPosition.x-jobPosition.x);
          const p4y=-1*(conjobPosition.y-jobPosition.y);
          const p3x=p4x-30;
          const p3y=p4y+(conjobPosition.pos<job.pos?-10:20);
          let points = [];

          if (0 === p4y) points = [p1x, p1y, p4x, p4y];
          else points = [p1x, p1y, p2x, p2y, p3x, p3y, p4x, p4y];

          connections.push(
            <React.Fragment key={`${j}-${i}-${con.id_nodo}`}>
              <Line
                x={conjobPosition.x}
                y={conjobPosition.y}
                points={points}
                tension={0.5}
                stroke={getLineColor(con.conx)}
                dash={getDash(con.conx)}
                strokeWidth={nodeSelected === `${j}-${i}-${con.id_nodo}` ? 2.5 : 1}
                shadowColor={getLineColor(con.conx)}
                shadowBlur={5}
                shadowOffsetX={0}
                shadowOffsetY={0}
                shadowOpacity={itemSelected === `${j}-${i}-${con.id_nodo}` ? 0.5 : 0}
              />
              <Line
                name={`${j}-${i}-${con.id_nodo}`}
                // onMouseEnter={handleItemEnter}
                // onMouseLeave={handleItemLeave}
                x={conjobPosition.x}
                y={conjobPosition.y}
                points={points}
                tension={0.5}
                dash={getDash(con.conx)}
                stroke={"rgba(255, 255, 255, 0)"}
                strokeWidth={10}
                onClick={(e) => {
                  if (linkMode.active) return;
                  handleAction(e, { job, con: { ...con, index: j } }, 'connection');
                  setNodeSelected(`${j}-${i}-${con.id_nodo}`);
                  clickJob({ job: { id_nodo: -1 } });
                }}
              />
            </React.Fragment>
          );
        }
      );
    });

    return (
      <Group
        x={0}
        y={30}
      >
        {connections}
      </Group>
    );
  }

  useEffect(() => {
    setWf(formatWfParam(wfParam));
  }, [updateWF]);

  return (
    <>
      <Stage
        width={5000}
        height={5000}
        className="wfcontainer"
        onWheel={scrollScale ? handleWheel : undefined}
        scaleX={scale ? scale : stage.scale}
        scaleY={scale ? scale : stage.scale}
        x={stage.x}
        y={stage.y}
        draggable
      >
        <Layer>
          { renderWfConnection() }
          { wf && renderWF(mode) }
        </Layer>
      </Stage>
    </>
  );
};
